// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RecentDocument } from "@conklin/App/Handlers/XNG/LoadRecentDocuments";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xRecentDocumentsStateType = Readonly<{
    documents?: RecentDocument[];
}>;

export const initialXRecentDocuments: xRecentDocumentsStateType = {
    documents: [],
};

const reducer = {
    "xRecentDocuments/update": (draft: Draft<xRecentDocumentsStateType>, action: { documents: RecentDocument[] }) => {
        draft.documents = action.documents;
    },
};

const xRecentDocuments = createTypedReducerWithImmer(initialXRecentDocuments, reducer);

(reducers as any).xRecentDocuments = xRecentDocuments;

export type xRecentDocumentsState = {
    xRecentDocuments: xRecentDocumentsStateType;
} & ApplicationState;

type xRecentDocumentsReducers = {
    [key: string]: typeof xRecentDocuments;
};

export type xRecentDocumentsActions =
    | Parameters<xRecentDocumentsReducers[keyof xRecentDocumentsReducers]>[1]
    | AnyAction;
